import React, { Component } from 'react';
import '../css/getMudar.css';

class getMudar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cuentas: [],
      cuentaSeleccionada: '',
      itemsCuenta: [],
      modo: '',
      cuentasHabilitadas: [],
      cuentaDestino: '',
      itemSeleccionado: '',
      cantidadMover: 1,
      itemsParaMover: []
    };
  }

  componentDidMount() {
    const url = this.props.url_proxyurl + this.props.url_global + "webservices/getCuentasActivasM/";
    fetch(url)
      .then(res => res.json())
      .then(data => this.setState({ cuentas: data }))
      .catch(console.log);
  }

  seleccionarCuenta = (id_cabecera) => {
    this.setState({ cuentaSeleccionada: id_cabecera, itemsCuenta: [], modo: '', cuentaDestino: '', itemsParaMover: [], itemSeleccionado: '' });
    fetch(this.props.url_proxyurl + this.props.url_global + `webservices/getItemsCuenta/${id_cabecera}`)
      .then(res => res.json())
      .then(data => this.setState({ itemsCuenta: data }))
      .catch(err => console.error('Error al obtener items de la cuenta:', err));
  }

  cambiarModo = (modo) => {
    this.setState({ modo });
    const { cuentaSeleccionada } = this.state;
    const nombre_maquina = this.props.nombre_maquina;

    fetch(this.props.url_proxyurl + this.props.url_global + `webservices/verificarCuenta/${cuentaSeleccionada}/${nombre_maquina}`)
      .then(res => res.json())
      .then(res => {
        if (res[0].estado === 'ok') {
          const destinoURL = modo === 'cuenta'
            ? 'webservices/getCuentasHabilitadasDC'
            : `webservices/getCuentaDestino/${cuentaSeleccionada}`;

          fetch(this.props.url_proxyurl + this.props.url_global + destinoURL)
            .then(r => r.json())
            .then(data => this.setState({ cuentasHabilitadas: data }))
            .catch(e => console.error('Error al obtener cuentas destino:', e));
        } else {
          alert('❌ La cuenta seleccionada no está activa.');
        }
      });
  }

  agregarItemParaMover = () => {
    const { itemSeleccionado, cantidadMover, itemsCuenta, itemsParaMover } = this.state;

    const idItem = parseInt(itemSeleccionado);
    const cantidadSolicitada = parseFloat(cantidadMover);
    

    if (isNaN(idItem) || isNaN(cantidadSolicitada) || cantidadSolicitada <= 0) {
      alert('⚠️ Seleccione un ítem y una cantidad válida.');
      return;
    }

    const itemObj = itemsCuenta.find(i => Number(i.id_detalle) === Number(idItem));
    if (!itemObj) {
      alert('⚠️ El ítem seleccionado no existe.');
      return;
    }

    const cantidadDisponible = Number(itemObj.cantidad || 0);
    const yaRegistrado = itemsParaMover.find(i => Number(i.id_detalle) === Number(itemObj.id_detalle));
    const cantidadExistente = yaRegistrado ? yaRegistrado.cantidad : 0;

    if (cantidadExistente + cantidadSolicitada > cantidadDisponible) {
      alert(`❌ No puede mudar más de ${cantidadDisponible} unidades del ítem seleccionado.`);
      return;
    }

    let nuevosItems;
    if (yaRegistrado) {
      nuevosItems = itemsParaMover.map(i =>
        i.id_detalle === itemObj.id_detalle ? { ...i, cantidad: i.cantidad + cantidadSolicitada } : i
      );
    } else {
      nuevosItems = [...itemsParaMover, { ...itemObj, cantidad: cantidadSolicitada }];
    }

    this.setState({ itemsParaMover: nuevosItems });
  }

  mudarCuentaCompleta =()=>{
    const { cuentaSeleccionada, cuentaDestino } = this.state;
    if (!cuentaDestino ) {
      alert('⚠️ Seleccione cuenta destino');
      return;
    }
    fetch(this.props.url_proxyurl + this.props.url_global + 'webservices/mudarCuenta', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        origen: cuentaSeleccionada,
        destino: cuentaDestino
      })
    })
      .then(res => res.json())
      .then(() => {
        this.props.Abtn_encerar_cuenta()
      })
      .catch(() => alert('❌ Error al mudar items.'));
  }
  confirmarMudanzaItems = () => {
    const { cuentaSeleccionada, cuentaDestino, itemsParaMover } = this.state;
    if (!cuentaDestino || itemsParaMover.length === 0) {
      alert('⚠️ Seleccione cuenta destino y agregue items.');
      return;
    }

    fetch(this.props.url_proxyurl + this.props.url_global + 'webservices/mudarItems', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        origen: cuentaSeleccionada,
        destino: cuentaDestino,
        items: itemsParaMover.map(i => ({ id_detalle: i.id_detalle, cantidad: i.cantidad }))
      })
    })
      .then(res => res.json())
      .then(() => {
        this.props.Abtn_encerar_cuenta()
      })
      .catch(() => alert('❌ Error al mudar items.'));
  }

  render() {
    const { cuentas, cuentaSeleccionada, itemsCuenta, modo, cuentasHabilitadas, itemsParaMover, itemSeleccionado } = this.state;
    const itemObj = itemsCuenta.find(i => i.id_detalle === parseInt(itemSeleccionado));
    const maxCantidad = itemObj ? itemObj.cantidad : 1;

    return (
      <div className="mudar-pos-container">
        <button className="btn_menu" onClick={() => this.props.Abtn_encerar_cuenta()}>Regresar</button>
        <h2 className="titulo">🔄 Mudar Cuentas o Productos</h2>
        <div className="form-group">
          <label>Cuenta Origen:</label>
          <select className="select" onChange={(e) => this.seleccionarCuenta(e.target.value)} value={cuentaSeleccionada}>
            <option value="0">-- Seleccione --</option>
            {cuentas.map(c => (
              <option key={c.id_cabecera} value={c.id_cabecera}>{c.cuenta} - {c.cliente}</option>
            ))}
          </select>
        </div>

        {cuentaSeleccionada && (
          <>
            <table className="tabla">
              <thead>
                <tr><th>Item</th><th>Cantidad</th></tr>
              </thead>
              <tbody>
                {itemsCuenta.map(item => (
                  <tr key={item.id_detalle}><td>{item.item}</td><td>{item.cantidad}</td></tr>
                ))}
              </tbody>
            </table>

            <div className="modo-toggle">
              <button
                className={`modo-boton ${this.state.modo === 'cuenta' ? 'activo' : ''}`}
                onClick={() => this.cambiarModo('cuenta')}
              >
                Mudar Cuenta Completa
              </button>
              <button
                className={`modo-boton ${this.state.modo === 'item' ? 'activo' : ''}`}
                onClick={() => this.cambiarModo('item')}
              >
                Mudar por Ítems
              </button>
            </div>
          </>
        )}

        {modo === 'cuenta' && cuentasHabilitadas.length > 0 && (
          <div className="seccion">
            <label>Cuenta Destino:</label>
            <select className="select" onChange={(e) => this.setState({ cuentaDestino: e.target.value })}>
              <option value="">-- Seleccione --</option>
              {cuentasHabilitadas.map(c => (
                <option key={c.id_cabecera} value={c.id_cabecera}>{c.cuenta} - {c.cliente}</option>
              ))}
            </select>
            <button className="boton confirmar" onClick={this.mudarCuentaCompleta}>✅ Mudar Cuenta</button>
          </div>
        )}

        {modo === 'item' && cuentasHabilitadas.length > 0 && (
          <div className="seccion">
            <label>Cuenta Destino:</label>
            <select className="select" onChange={(e) => this.setState({ cuentaDestino: e.target.value })}>
              <option value="">-- Seleccione --</option>
              {cuentasHabilitadas.map(c => (
                <option key={c.id_cabecera} value={c.id_cabecera}>{c.cuenta} - {c.cliente}</option>
              ))}
            </select>

            <label>Ítem:</label>
            <select className="select" value={itemSeleccionado} onChange={(e) => {
                  const id = e.target.value;
                  const item = this.state.itemsCuenta.find(i => parseInt(i.id_detalle) === parseInt(id));
                  const cantidad = item ? parseFloat(item.cantidad) : 1;
                  this.setState({
                    itemSeleccionado: id,
                    cantidadMover: cantidad
                  });
                }}>
              <option value="">-- Seleccione --</option>
              {itemsCuenta.map(i => (
                <option key={i.id_detalle} value={i.id_detalle}>{i.item}</option>
              ))}
            </select>

            <label>Cantidad:</label>
            <input type="number" className="input" min="0.01" step="1" max={maxCantidad} value={this.state.cantidadMover} onChange={(e) => this.setState({ cantidadMover: e.target.value })} />

            <button className="boton agregar" onClick={this.agregarItemParaMover}>➕ Agregar</button>

            {itemsParaMover.length > 0 && (
              <>
                <table className="tabla">
                  <thead><tr><th>Item</th><th>Cantidad</th></tr></thead>
                  <tbody>
                    {itemsParaMover.map(i => (
                      <tr key={i.id_detalle}><td>{i.item}</td><td>{i.cantidad}</td></tr>
                    ))}
                  </tbody>
                </table>
                <button className="boton confirmar" onClick={this.confirmarMudanzaItems}>✅ Confirmar Mudanza</button>
              </>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default getMudar;